angular.module('access.Utils')
    .factory('RedirectHandler', [function () {
        return {
            request: function (config) {
                if (config.failOnRedirect === true) {
                    config.headers['X-Requested-With'] = 'XMLHttpRequest';
                }

                return config;
            }
        }
    }]);
